// extracted by mini-css-extract-plugin
export default {"logo":"HeaderLogo_logo__Nkx6i","logoTextContainer":"HeaderLogo_logoTextContainer__7+geH"};